import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { darwinService } from "@/services/darwinService";

/** Asks the support team to add a capability Darwin does not have. */
export const useRequestDarwinTool = () => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: darwinService.requestTool,
        onSuccess: () => {
            toast.success(t("darwin_tool_requested"));
        },
        onError: (error) => {
            console.error("Failed to request a Darwin tool:", error);
            toast.error(t("darwin_tool_request_failed"));
        },
    });
};

/** Thumbs up/down on a Darwin reply. Sent quietly; only a failure is shown. */
export const useSendDarwinRating = () => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: darwinService.rateMessage,
        onError: (error) => {
            console.error("Failed to send Darwin rating:", error);
            toast.error(t("darwin_feedback_failed"));
        },
    });
};
